// Name
export const doiTooltip = 'doi tooltip'
export const isbnTooltip = 'isbn tooltip'
export const clickToContinueCiting = 'click to continue citing'
export const exportCitation = 'export citation'
export const createCitation = 'create citation'
export const upgradeCreateCitation = 'upgrade to create citation'
export const upgradeViewCitationList = 'upgrade to view citation list'
export const viewCitationList = 'view citation list'
export const offerPriceModal = 'offer price modal'
export const tryCitationStyles = 'try citation styles'
export const changeCitationStyle = 'change citation style'
export const addCitationModal = 'add citation modal'
export const citationsExpiring = 'citations expiring'
export const saveAllCitations = 'save all citations'

export type ComponentName =
  | typeof clickToContinueCiting
  | typeof doiTooltip
  | typeof isbnTooltip
  | typeof exportCitation
  | typeof createCitation
  | typeof upgradeCreateCitation
  | typeof upgradeViewCitationList
  | typeof viewCitationList
  | typeof offerPriceModal
  | typeof tryCitationStyles
  | typeof changeCitationStyle
  | typeof addCitationModal
  | typeof citationsExpiring
  | typeof saveAllCitations

// Region
export const emptyCitationSearchResultRegion = 'empty citation search result'
export const citationSearchWidgetRegion = 'citation search widget'
export const unlockCitationRegion = 'shown unlock'

export type ComponentRegion =
  | typeof emptyCitationSearchResultRegion
  | typeof citationSearchWidgetRegion
  | typeof unlockCitationRegion

// ElementType
export const componentElemType = 'component'

type ComponentElementType = typeof componentElemType
export type Metadata = { style?: string; source?: string; bibliographyId?: string }

export interface ClickstreamComponentViewPayload {
  name: ComponentName
  type: ComponentElementType
  region?: ComponentRegion
  text?: string
  metadata?: Metadata
}

export type ComponentViews = {
  doiLink: (region: ComponentRegion) => ClickstreamComponentViewPayload
  isbnLink: (region: ComponentRegion) => ClickstreamComponentViewPayload
  unlockModalOpen: () => ClickstreamComponentViewPayload
  exportToWordOpen: (text: string) => ClickstreamComponentViewPayload
  citationLimitApproaching: (text: string) => ClickstreamComponentViewPayload
  citationLimitReached: (text: string) => ClickstreamComponentViewPayload
  foldersPageExpiration: (text: string) => ClickstreamComponentViewPayload
  bibPageExpiration: (text: string) => ClickstreamComponentViewPayload
  priceExperimentModal: (text: string) => ClickstreamComponentViewPayload
  ucfUpgradeModalOpen: (metadata: Metadata) => ClickstreamComponentViewPayload
  changeCitationStyleModal: (metadata: Metadata) => ClickstreamComponentViewPayload
  newCitationListModal: (metadata: Metadata) => ClickstreamComponentViewPayload
  citationValidityBanner: (metadata: Metadata) => ClickstreamComponentViewPayload
  createAccountBanner: () => ClickstreamComponentViewPayload
}

export const componentViews: ComponentViews = {
  doiLink: (region) => ({
    name: doiTooltip,
    type: componentElemType,
    region,
  }),
  isbnLink: (region) => ({
    name: isbnTooltip,
    type: componentElemType,
    region,
  }),
  unlockModalOpen: () => ({
    name: clickToContinueCiting,
    type: componentElemType,
    region: unlockCitationRegion,
  }),
  exportToWordOpen: (text) => ({
    name: exportCitation,
    type: componentElemType,
    text,
  }),
  citationLimitApproaching: (text) => ({
    name: createCitation,
    type: componentElemType,
    text,
  }),
  citationLimitReached: (text: string) => ({
    name: upgradeCreateCitation,
    type: componentElemType,
    text,
  }),
  foldersPageExpiration: (text: string) => ({
    name: upgradeViewCitationList,
    type: componentElemType,
    text,
  }),
  bibPageExpiration: (text: string) => ({
    name: viewCitationList,
    type: componentElemType,
    text,
  }),
  priceExperimentModal: (text: string) => ({
    name: offerPriceModal,
    type: componentElemType,
    text,
  }),
  ucfUpgradeModalOpen: (metadata: Metadata) => ({
    name: tryCitationStyles,
    type: componentElemType,
    metadata,
  }),
  changeCitationStyleModal: (metadata: Metadata) => ({
    name: changeCitationStyle,
    type: componentElemType,
    metadata,
  }),
  newCitationListModal: (metadata: Metadata) => ({
    name: addCitationModal,
    type: componentElemType,
    metadata,
  }),
  citationValidityBanner: (metadata: Metadata) => ({
    name: citationsExpiring,
    type: componentElemType,
    metadata,
  }),
  createAccountBanner: () => ({
    name: saveAllCitations,
    type: componentElemType,
  }),
}

export const componentOrigins = Object.keys(componentViews).reduce(
  (origins, componentViewName) => ({
    ...origins,
    [componentViewName]: componentViewName,
  }),
  {} as componentViewOrigins
)

type componentViewOrigins = {
  [ComponentView in keyof ComponentViews]: ComponentView
}

type ComponentViewOrigins = keyof componentViewOrigins

export type ComponentPayload = {
  name?: ComponentName
  origin?: ComponentViewOrigins
  region?: ComponentRegion
  text?: string
  metadata?: Metadata
}
